<template>
	<div v-if="user">
		<div class="d-flex justify-content-between align-items-center border-bottom p-3">
			<div>
				<h6>Verificar correo electrónico</h6>
				<p class="m-0">
					Asegurate de que tu correo sea el correcto, ya que enviaremos los códigos de acceso a los eventos
					que asistas por este medio.
				</p>
			</div>
			<div>
				<div class="btn btn-success btn-sm ml-4" v-if="user.emailValidated">Verificado</div>
				<div class="btn btn-secondary btn-sm ml-4" v-if="!user.emailValidated" @click="verifyEmail">
					Verificar
				</div>
				<div class="btn btn-secondary btn-sm ml-4" v-if="verifyingEmail">
					Enviando correo <span class="btn-loader" />
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-between align-items-center border-bottom p-3">
			<div>
				<h6>Verificar número de teléfono</h6>
				<p class="m-0">
					Validá tu número de teléfono para que podamos enviarte información sobre los eventos y entradas a
					los que asistís.
				</p>
			</div>
			<div>
				<div class="btn btn-success btn-sm ml-4" v-if="user.phoneValidated">Verificado</div>
				<router-link
					tag="a"
					to="/account/security/phone-validation"
					class="btn btn-secondary btn-sm ml-4"
					v-if="!user.phoneValidated"
				>
					Verificar
				</router-link>
			</div>
		</div>
		<div class="d-flex justify-content-between align-items-center border-bottom p-3">
			<div>
				<h6>Contraseña</h6>
				<p class="m-0" v-if="user.passwordUpdatedAt">
					Ultima actualización: {{ user.passwordUpdatedAt | moment("from", "now") }}
				</p>
			</div>
			<div>
				<router-link tag="button" to="/account/password-change" class="btn btn-secondary btn-sm"
					>Cambiar contraseña</router-link
				>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

import mixins from "@/mixins/mixins"

export default {
	name: "UserSecurity",
	mixins: [mixins],
	data() {
		return {
			loading: false,
			saving: false,
			verifyingEmail: false,
			user: null
		}
	},
	async beforeMount() {
		this.loading = true

		await this.load()

		this.loading = false
	},
	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query {
							userLogged {
								id
								name
								lastname
								email
								phone {
									countryCode
									national
									international
									type
									validated
								}
								document {
									type
									number
								}
								passwordUpdatedAt
								emailValidated
								phoneValidated
							}
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.user = this.$omitDeep(data.userLogged, "__typename")

					this.loading = false
				})
				.catch((err) => {
					this.$toast.error("Error al cargar los dato de usuario")
				})
		},

		verifyEmail() {
			this.verifyingEmail = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation {
							userVerifyEmailRequest
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.verifyingEmail = false
					this.$toast.success("Se ha enviado un correo de verificación")
				})
				.catch((err) => {
					this.verifyingEmail = false
					this.$toast.error("Error al enviar el correo de verificación")
				})
			this.verifyingEmail = false
		}
	}
}
</script>

<style scoped>
.row {
	margin: auto;
	max-width: 360px;
}
</style>
